export const CVAPPS_TEST_IDS = {
 CVAPPS_CANCEL_BUTTON: "createCVApps_cancelButton",
 CVAPPS_SUBMIT_BUTTON: "createCVApps_submitButton",
 CVAPPS_NAME_INPUT: "createCVApps_nameInput",
 CVAPPS_TYPE_DROPDOWN: "createCVApps_typeDropdown",
 CVAPPS_IMAGE_INPUT: "createCVApps_imageInput", 
 CVAPPS_VERSION_INPUT: "createCVApps_versionInput", 
 CVAPPS_CPU_INPUT: "createCVApps_cpuInput",
 CVAPPS_MEMORY_INPUT: "createCVApps_memoryInput",
 CVAPPS_DELETE_MODAL_CONFIRM_BUTTON: "cvApps_deleteModalConfirmButton", 
 CVAPPS_DELETE_MODAL_CLOSE_BUTTON: "cvApps_deleteModalCloseButton", 
 CVAPPS_SEARCH_INPUT: "cvApps_searchInput", 
 
}; 